import {combineReducers} from 'redux';
import {loadingReducer, errorReducer} from './reducers';

export const reducer = combineReducers({
    loading: loadingReducer,
    error: errorReducer,
});


export {createLoadingSelector, createErrorMessageSelector} from './selectors';